import * as React from 'react';
import { useTranslation } from 'react-i18next';

import Calendar from '@/assets/calendar.png';

export type TourButtonRequestProps = {
  tourRequestURL: string;
  actionLabel?: React.ReactNode | string;
  icon?: boolean;
  iconURL?: string;
};

export const TourButtonRequest = ({
  tourRequestURL,
  actionLabel,
  iconURL,
  icon = true,
}: TourButtonRequestProps) => {
  const { t } = useTranslation();

  return (
    <span className="flex items-center justify-center bg-md-yellow">
      <a
        href={tourRequestURL}
        className="text-base uppercase font-extrabold text-md-black cursor-pointer font-black border-2 rounded px-5 border-md-black hover:bg-[#fffbe9] hover:no-underline hover:text-md-black transition-all duration-300 ease-in-out"
        target="_blank"
        rel="noreferrer"
        style={{ padding: '6px 20px 6px 15px' }}
      >
        {icon && (
          <img
            className="inline mr-2 relative"
            src={iconURL || Calendar}
            alt={t('TourRequest.calendar')}
            width="40"
          />
        )}
        {actionLabel || t('TourRequest.title')}
      </a>
    </span>
  );
};
